import React, { useContext } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PATHS from "../../../../constants/paths";

import {
  IconStyled,
  ButtonOption,
  Logo,
  OffCanvasHeader,
  NavLink,
  ButtonOption2,
} from "./styled";
import { AuthContainer } from "../../../security/auth/auth.container";

import { Can, AbilityContext } from "../../../security/permissions/Can";
import { USER_PERMISSIONS } from "../../../security/permissions/rolesPermission";
import { checkBootstrapSizeBreak } from "../../../../utils/device/checkDevice";

const Sidebar = (props) => {
  const auth = AuthContainer.useContainer();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { offCanvas } = props;
  const context = useContext(AbilityContext);
  const deviceSize = checkBootstrapSizeBreak();

  const logout = async () => {
    auth.logout();
    openCenteredPopup(
      `https://login.microsoftonline.com/99dbb24d-723f-44f0-b082-24b8ce4784d4/oauth2/logout`,
      `logout azureAd`,
      150,
      150
    );
  };

  const handlerSelectOption = async (key) => {
    switch (key) {
      case "home":
        navigate(PATHS.HOME);
        break;
      case "accountLinks":
        navigate(PATHS.ACCOUNT_LINKS);
        break;
      case "captioConcepts":
        navigate(PATHS.CAPTIO_CONCEPTS_LIST);
        break;

      case "close_session":
        logout();
        break;

      default:
        break;
    }
  };

  return (
    <>
      <ul className="nav flex-column text-white w-100">
        {offCanvas && (
          <OffCanvasHeader className="offcanvas-header">
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </OffCanvasHeader>
        )}
        <a
          href={`${process.env.REACT_APP_PROTOCOL}://${
            process.env.REACT_APP_HOST
          }${
            process.env.REACT_APP_PORT ? `:${process.env.REACT_APP_PORT}` : ""
          }/client/home`}
          className="nav-link-logo text-center mb-4 mt-3"
        >
          <Logo
            src={`/assets/themes/${process.env.REACT_APP_THEME}/images/logo_ama.png`}
            alt="logo"
            className="logo"
            offCanvas={offCanvas}
          />
        </a>

        <NavLink href="#" className="selectable nav-link mt-2">
          {/* <span className="mx-2"> */}
          <ButtonOption
            $active={true}
            data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
            onClick={() => {
              handlerSelectOption("home");
            }}
          >
            <IconStyled className="fa-solid fa-gauge" />
            {t("home")}
          </ButtonOption>

          {/* </span> */}
        </NavLink>
        <Can do={USER_PERMISSIONS.VIEW_ACCOUNT_LIST}>
          <NavLink href="#" className="selectable nav-link">
            {/* <span className="mx-2"> */}
            <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("accountLinks");
              }}
            >
              <IconStyled className="fa-solid fa-file-invoice-dollar" />
              {t("accountLinks")}
            </ButtonOption>

            {/* </span> */}
          </NavLink>
        </Can>
        <Can do={USER_PERMISSIONS.VIEW_CAPTIO_CONCEPTS}>
          <NavLink href="#" className="selectable nav-link">
            {/* <span className="mx-2"> */}
            <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("captioConcepts");
              }}
            >
              <IconStyled className="fa-solid fa-receipt" />
              {t("captioConcepts")}
            </ButtonOption>

            {/* </span> */}
          </NavLink>
        </Can>
        {/* <Can do={USER_PERMISSIONS.TO_EVAL}>
          <NavLink href="#" className="selectable nav-link">
            <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("toEval");
              }}
            >
              <IconStyled className="fa-solid fa-user-pen" />
              {t("toEval")}
            </ButtonOption>
          </NavLink>
        </Can> */}
      </ul>
      <span href="#" className="nav-link w-100 mb-2">
        <ButtonOption2
          $active={true}
          onClick={() => {
            handlerSelectOption("close_session");
          }}
        >
          <IconStyled className="fas fa-power-off" />
          {t("close_session")}
        </ButtonOption2>
      </span>
    </>
  );
};

// Sidebar.contextType = AbilityContext;

Sidebar.propTypes = {
  nickname: PropTypes.string,
  offCanvas: PropTypes.bool,
};

export default Sidebar;

export const openCenteredPopup = (url, title, w, h) => {
  // Fixes dual-screen position                             Most browsers      Firefox
  const dualScreenLeft =
    window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop =
    window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : window.screen.width;
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
    ? document.documentElement.clientHeight
    : window.screen.height;

  const systemZoom = width / window.screen.availWidth;
  const left = (width - w) / 2 / systemZoom + dualScreenLeft;
  const top = (height - h) / 2 / systemZoom + dualScreenTop;
  const newWindow = window.open(
    url,
    title,
    `
      scrollbars=no,
      toolbar=no,
      location=no,
      directories=no,
      status=no,
      menubar=no,
      resizable=no,
      copyhistory=no,
      width=${w / systemZoom}, 
      height=${h / systemZoom}, 
      top=${top}, 
      left=${left}
      `
  );

  newWindow?.focus();

  setTimeout(() => {
    newWindow.close();
  }, 5000);
};
